import React from 'react'
import { scrollIntoView } from '@/shared/lib/utils/scrollIntoView'
import cls from './Navigation.module.scss'

export const Navigation = () => {
    const navigationItem = (content) => {
        return <li className={cls.NavigationItem}>{content}</li>
    }
    return (
        <section className={cls.Navigation}>
            {navigationItem(
                <p onClick={() => scrollIntoView('gamblinglobby')}>Gambling lobby</p>
            )}
            {navigationItem(<p onClick={() => scrollIntoView('productList')}>Products</p>)}
            {navigationItem(<p onClick={() => scrollIntoView('adminservices')}>Admin services</p>)}
            {navigationItem(<p onClick={() => scrollIntoView('contact')}>Contact us</p>)}
        </section>
    )
}
